import React, { useMemo, useEffect } from "react";
import { Provider } from "@rollbar/react";
import Rollbar from "rollbar";
import { initErrorLogger } from "@Libs/DataLayer/services/errorLogger";

const rollbarConfig = {
  accessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
  enabled: process.env.NODE_ENV === "production",
  // Disable global handlers so only manual logging occurs
  captureUncaught: false,
  captureUnhandledRejections: false,
  autoInstrument: true,
  payload: {
    environment: process.env.NODE_ENV,
    client: {
      javascript: {
        code_version: "1.0.0",
        source_map_enabled: true,
      },
    },
    // Optional: scrub sensitive fields from telemetry
    scrubFields: [
      "authorization",
      "cookie",
      "x-csrf-token",
      "password",
      "passwd",
      "secret",
      "token",
    ],
  },
} as const;

interface IRollBarProvider {
  children: React.ReactNode;
}

export const RollBarProvider: React.FC<IRollBarProvider> = (props) => {
  const rollbar = useMemo(() => new Rollbar(rollbarConfig), []);

  // Initialize error logger for React Query with this Rollbar instance
  useEffect(() => {
    initErrorLogger(rollbar);
  }, [rollbar]);

  return <Provider instance={rollbar}>{props?.children}</Provider>;
};
